import { TableHeaderColumn, TableHeaderRow } from '@rio-cloud/rio-uikit/Table';
import { useIntl } from 'react-intl';

export const TourTableHeader = () => {
    const intl = useIntl();

    const tour = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.tour' });
    const vehicle = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.vehicle' });
    const trailer = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.trailer' });
    const driver = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.driver' });
    const tourStart = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.tourStart' });
    const tourEnd = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.tourEnd' });
    const progress = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.progress' });
    const status = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.tours.table.header.status' });

    return (
        <TableHeaderRow>
            <TableHeaderColumn columnKey='searchName' label={tour} width='20%' sortable />
            <TableHeaderColumn columnKey='truckLicensePlate' label={vehicle} sortable />
            <TableHeaderColumn columnKey='trailerLicensePlate' label={trailer} sortable />
            <TableHeaderColumn columnKey='driverName' label={driver} sortable />
            <TableHeaderColumn columnKey='firstStopEndTarget' label={tourStart} sortable />
            <TableHeaderColumn columnKey='lastStopEndTarget' label={tourEnd} sortable />
            <TableHeaderColumn columnKey='progressPercentage' label={progress} width={200} sortable />
            <TableHeaderColumn columnKey='status' label={status} />
        </TableHeaderRow>
    );
};
